<template>
  <div class="md-layout" id="manage-university-score">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">
            {{
              $t("management_university_score.title", {
                name: title
              })
            }}
          </h4>
        </md-card-header>
        <md-card-actions
          class="text-right md-alignment-right management-uni-container"
        >
          <md-button
            type="button"
            class="md-success"
            @click="downloadCertificateCover"
            style="margin-right: 8px"
            >{{ $t("management_university_score.export_certificate_cover") }}
          </md-button>
          <md-button
            type="button"
            class="md-success"
            @click="downloadPDF"
            style="margin-right: 8px"
            >{{ $t("management_university_score.export_certificate") }}
          </md-button>
          <md-button
            type="button"
            class="md-success"
            @click="exportExcel"
            style="margin-right: 8px"
            >{{ $t("management_university_score.export_excel") }}
          </md-button>
          <md-button
            type="button"
            class="md-warning"
            @click="updateRatingCriteria"
            v-if="universityInfo && universityInfo.id && !template_updated"
            >{{ $t("management_university_score.update_rating_criteria") }}
          </md-button>
          <router-link
            data-toggle="dropdown"
            class="management-uni-btn"
            v-if="universityInfo && universityInfo.id"
            :to="{
              name: 'UniversityEditForm',
              params: { id: universityInfo.id }
            }"
          >
            <p class="content-button">
              {{ $t("university.edit_info") }}
            </p>
          </router-link>
        </md-card-actions>
        <md-card-content>
          <!-- Update university info  -->
          <div
            class="md-layout-item md-size-100 md-xsmall-size-100 university-info"
          >
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-xsmall-size-100">
                <div class="md-layout">
                  <!--   university_division    -->
                  <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('university.university_division_name')"
                      >
                        {{ $t("university.university_division_name") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-select
                            v-model="universityInfo.university_division_id"
                            disabled
                            :name="$t('university.university_type_name')"
                          >
                            <md-option
                              :value="option.id"
                              v-for="option in universityDivisionOptions"
                              :key="option.id"
                              >{{ option.name }}
                            </md-option>
                          </md-select>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--   university_type    -->
                  <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('university.university_type_name')"
                      >
                        {{ $t("university.university_type_name") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-select
                            v-model="universityInfo.university_type_id"
                            disabled
                            :name="$t('university.university_type_name')"
                          >
                            <md-option
                              :value="option.id"
                              v-for="option in universityTypeOptions"
                              :key="option.id"
                              >{{ option.name }}
                            </md-option>
                          </md-select>
                        </md-field>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- delivery_date and valid_date -->
                <div class="md-layout">
                  <!--   university_division    -->
                  <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('university.delivery_date')"
                      >
                        {{ $t("university.delivery_date") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-input
                            type="date"
                            v-model="universityInfo.delivery_date"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--   university_type    -->
                  <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <div class="md-layout">
                      <label
                        class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                        :for="$t('university.valid_date')"
                      >
                        {{ $t("university.valid_date") }}
                      </label>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-field>
                          <md-input
                            type="date"
                            v-model="universityInfo.valid_date"
                          ></md-input>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <!--   is_public    -->
                  <div
                    class="md-layout-item md-size-20 md-xsmall-size-100 text-align-left"
                  >
                    <div class="md-layout">
                      <div
                        class="md-layout-item md-size-20 md-xsmall-size-100"
                      ></div>
                      <div class="md-layout-item md-size-80 md-xsmall-size-100">
                        <md-checkbox
                          v-model="universityInfo.is_public"
                          disabled
                        >
                          {{ $t("university.is_public") }}
                        </md-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Table ratings  -->
          <table class="mus-table">
            <colgroup>
              <col span="1" style="width: 20%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
            </colgroup>
            <tbody>
              <tr class="mus-table-row mus-table-heading-row">
                <td
                  class="mus-table-col mus-table-heading-col"
                  v-for="(label, index) in columns"
                  :key="'mus-' + index"
                >
                  <p class="mus-table-head-label">
                    {{ label }}
                  </p>
                </td>
                <td class="mus-table-col mus-table-heading-col">
                  <p class="mus-table-head-label">
                    {{ $t("common.actions") }}
                  </p>
                </td>
              </tr>

              <!--    Criteria Category    -->
              <template v-for="(category, categoryIndex) in tableData">
                <tr
                  class="mus-table-row mus-table-category-row"
                  :key="'mus-category-item-' + categoryIndex"
                >
                  <template
                    v-for="(categoryData, categoryDataName) in category"
                  >
                    <td
                      class="mus-table-col"
                      v-if="isDisplay(categoryDataName)"
                      :key="'mus-table-cell-' + categoryDataName"
                      @click="displayCriteria(category)"
                    >
                      <div
                        class="mus-table-content-col"
                        v-if="categoryDataName === 'name'"
                      >
                        <p class="mus-table-cell">
                          {{ categoryIndex + 1 + ". " + categoryData }}
                        </p>
                        <md-tooltip
                          md-direction="top"
                          v-if="category.description"
                          >{{ category.description }}
                        </md-tooltip>
                      </div>
                      <div v-else-if="categoryDataName === 'weight'">
                        <p class="mus-category-weight">
                          {{ calcCategoryWeight(category) }}
                        </p>
                      </div>
                      <div v-else-if="categoryDataName === 'score'">
                        {{ calcCategoryScore(category) }}
                      </div>
                      <div
                        v-else-if="
                          categoryDataName === 'benchmark' ||
                            categoryDataName === 'achievement' ||
                            categoryDataName === 'min_point' ||
                            categoryDataName === 'unit'
                        "
                      ></div>
                      <div
                        v-else-if="categoryDataName === 'star'"
                        class="category-star"
                      >
                        <star-rating
                          v-model="calcCategoryStar(category)[0]"
                          :read-only="true"
                          :star-size="20"
                          :border-width="2"
                          border-color="#d8d8d8"
                          :round-start-rating="true"
                          :show-rating="false"
                          :rounded-corners="true"
                          :star-points="starPoints"
                          :animate="true"
                        ></star-rating>
                        <div
                          v-if="category.plus_text"
                          :class="[
                            {
                              'category-star-elite-text':
                                category.plus_text.toUpperCase() === 'ELITE'
                            }
                          ]"
                        >
                          {{ category.plus_text }}
                        </div>
                      </div>
                      <div v-else>
                        <p class="mus-table-cell">
                          {{ categoryData }}
                        </p>
                      </div>
                    </td>
                  </template>
                  <td class="mus-table-col mus-table-actions"></td>
                </tr>

                <!--    Criteria    -->
                <template
                  v-for="(criteria, criteriaIndex) in category.criteria"
                >
                  <tr
                    class="mus-table-row mus-table-child-row"
                    :key="
                      'mus-child-item-' + categoryIndex + '' + criteriaIndex
                    "
                    v-show="category.showCriteria"
                  >
                    <template
                      v-for="(criteriaData, criteriaDataName) in criteria"
                    >
                      <td
                        class="mus-table-col"
                        v-if="isDisplay(criteriaDataName)"
                        :key="'mus-table-cell-' + criteriaDataName"
                      >
                        <div
                          class="mus-table-content-col"
                          v-if="criteriaDataName === 'name'"
                        >
                          <p class="mus-table-cell">
                            {{
                              categoryIndex +
                                1 +
                                "." +
                                (criteriaIndex + 1) +
                                ". " +
                                criteriaData
                            }}
                          </p>
                          <md-tooltip
                            md-direction="top"
                            v-if="criteria.description"
                            >{{ criteria.description }}
                          </md-tooltip>
                        </div>
                        <div v-else-if="criteriaDataName === 'achievement'">
                          <md-field
                            v-if="criteria.achievement_options"
                            class="mus-table-select"
                          >
                            <md-select v-model="criteria[criteriaDataName]">
                              <md-option
                                v-for="(option,
                                index) in criteria.achievement_options"
                                :key="'achievement_options-' + index"
                                :value="option"
                                >{{ option }}
                              </md-option>
                            </md-select>
                          </md-field>
                          <input
                            v-else
                            class="mus-table-input"
                            min="0"
                            type="number"
                            v-model="criteria[criteriaDataName]"
                          />
                        </div>
                        <div v-else-if="criteriaDataName === 'weight'">
                          <p class="mus-category-weight">
                            {{ criteria[criteriaDataName] }}
                          </p>
                        </div>
                        <div v-else-if="criteriaDataName === 'score'">
                          <p class="mus-table-cell">
                            {{ calcCriteriaScore(criteria) }}
                          </p>
                        </div>
                        <div v-else-if="criteriaDataName === 'star'">
                          <star-rating
                            v-model="calcCriteriaStar(criteria)[0]"
                            :read-only="true"
                            :star-size="20"
                            :border-width="2"
                            border-color="#d8d8d8"
                            :round-start-rating="true"
                            :show-rating="false"
                            :rounded-corners="true"
                            :star-points="starPoints"
                            :animate="true"
                          ></star-rating>
                        </div>
                        <div v-else>
                          <p class="mus-table-cell">
                            {{ criteriaData }}
                          </p>
                        </div>
                      </td>
                    </template>
                    <td class="mus-table-col mus-table-actions">
                      <md-button
                        class="md-success md-actions-btn"
                        type="button"
                        v-if="
                          criteria.achievement !==
                            oldTableData[categoryIndex].criteria[criteriaIndex]
                              .achievement ||
                            parseFloat(criteria.score) !==
                              parseFloat(
                                oldTableData[categoryIndex].criteria[
                                  criteriaIndex
                                ].score || 0
                              )
                        "
                        @click.native="
                          saveUniversityCriteriaRating(
                            criteria,
                            categoryIndex,
                            criteriaIndex
                          )
                        "
                      >
                        {{ $t("common.save") }}
                      </md-button>
                    </td>
                  </tr>
                </template>
              </template>

              <!--   Total score    -->
              <tr
                class="mus-table-row mus-table-category-row mus-table-total-score-row"
              >
                <td
                  class="mus-table-col"
                  v-for="(label, column) in columns"
                  :key="'mus-total' + column"
                >
                  <div class="mus-table-content-col" v-if="column === 'name'">
                    <p class="mus-table-cell">
                      {{ $t("management_university_score.total_score") }}
                    </p>
                  </div>
                  <div v-else-if="column === 'weight'">
                    <p class="mus-category-weight">
                      {{ universitySummary.weight }}
                    </p>
                  </div>
                  <div v-else-if="column === 'score'">
                    {{ universitySummary.score }}
                  </div>
                  <div v-else-if="column === 'star'" class="category-star">
                    <star-rating
                      v-model="summaryStar"
                      :read-only="true"
                      :star-size="20"
                      :border-width="2"
                      border-color="#d8d8d8"
                      :round-start-rating="false"
                      :show-rating="false"
                      :rounded-corners="true"
                      :star-points="starPoints"
                      :animate="true"
                    ></star-rating>
                    <div
                      v-if="
                        universitySummary.extra &&
                          universitySummary.extra.toUpperCase() === 'ELITE'
                      "
                      :class="[
                        {
                          'category-star-elite-text':
                            universitySummary.extra.toUpperCase() === 'ELITE'
                        }
                      ]"
                    >
                      {{ universitySummary.extra }}
                    </div>
                  </div>
                  <div v-else></div>
                </td>
                <td class="mus-table-col mus-table-actions"></td>
              </tr>
            </tbody>
          </table>
        </md-card-content>
        <md-card-actions class="text-center submit-save-all-actions ">
          <md-button type="submit" class="md-success" @click="updateAll"
            >{{ $t("common.save_all") }}
          </md-button>
          <md-button native-type="button" @click="cancel"
            >{{ $t("common.cancel") }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { UniversityRatingsService } from "../../services/universityRatings.service";
import { UniversityService } from "../../services/university.service";
import StarRating from "vue-star-rating";
import queryHelper from "@/helpers/query-helper";
import { STAR_CONFIG } from "../../helpers/constants";
import { UniversityTypeService } from "../../services/universityType.service";
import { UniversityDivisionService } from "../../services/universityDivision.service";
import $ from "jquery";
import { NationService } from "../../services/nation.service";

export default {
  name: "ManageUniversityRatings",
  data() {
    return {
      starPoints: STAR_CONFIG.STAR_POINTS,
      title: "",
      perPageOptions: [5, 10, 25, 50],
      universityInfo: {},
      universityTypeOptions: [],
      universityDivisionOptions: [],
      tableData: [],
      oldTableData: [],
      universitySummary: {},
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 0
      },
      columns: {
        name: this.$t("management_university_score.name"),
        weight: this.$t("management_university_score.weight"),
        min_point: this.$t("management_university_score.min_point"),
        benchmark: this.$t("management_university_score.benchmark"),
        achievement: this.$t("management_university_score.real_achievement"),
        score: this.$t("management_university_score.score"),
        unit: this.$t("management_university_score.unit"),
        star: this.$t("management_university_score.star")
      },
      totalScore: 0,
      totalWeight: 0,
      maxStar: STAR_CONFIG.MAX_STAR,
      template_updated: true,
      uniCategoryRatings: [],
      ratingYearFallback: 0,
      params: {
        valid_date: null,
        delivery_date: null
      }
    };
  },
  components: {
    StarRating
  },
  created() {
    this.getDetailUniversity();
    this.getTableData();
    this.getUniversityTypeOptions();
    this.getUniversityDivisionOptions();
    this.getUniversityRatingSummaries();
    this.getUniversityCategoryRating();
  },
  methods: {
    downloadPDF() {
      let routeData = this.$router.resolve({
        name: "ExportPdf",
        params: { id: this.$route.params.id }
      });
      window.open(routeData.href, "_blank");
    },
    downloadCertificateCover() {
      let routeData = this.$router.resolve({
        name: "ExportCertificateCover",
        params: { id: this.$route.params.id }
      });
      window.open(routeData.href, "_blank");
    },
    async getUniversityCategoryRating() {
      const response = await new UniversityService().getRatetingByUniId(
        this.$route.params.id
      );
      if (!response) {
        return;
      }

      response.forEach(category => {
        category.star = category.star || null;
        category.weight = category.weight || 0;
        category.score = category.score || 0;
        category.extra = category.extra || "";
      });
      this.uniCategoryRatings = response;
    },
    async getNation() {
      const nation = new NationService().getNation(
        this.universityInfo.country_alpha_two_code
      );
      if (!nation) {
        return;
      }
      this.universityInfo.nation = nation.name;
    },
    getYearFromCreatedAt(createdAt) {
      if (!createdAt) return 0;
      const year = new Date(createdAt).getFullYear();
      return isNaN(year) ? 0 : year;
    },
    async getTableData() {
      let tableData = await new UniversityService().getRatetingByUniId(
        this.$route.params.id
      );
      this.ratingYearFallback = 0;
      for (const category of tableData) {
        if (category.created_at) {
          this.ratingYearFallback = this.getYearFromCreatedAt(
            category.created_at
          );
          break;
        }
        if (category.criteria && category.criteria.length) {
          const firstWithDate = category.criteria.find(c => c.created_at);
          if (firstWithDate) {
            this.ratingYearFallback = this.getYearFromCreatedAt(
              firstWithDate.created_at
            );
            break;
          }
        }
      }
      let sortedTabledData = [];
      tableData.forEach(uniCriteriaCategory => {
        let sortedUniCriteriaCategory = {
          id: uniCriteriaCategory.id,
          name: uniCriteriaCategory.criterion_category
            ? uniCriteriaCategory.criterion_category.name
            : "",
          description: uniCriteriaCategory.criterion_category
            ? uniCriteriaCategory.criterion_category.description
            : "",
          weight: uniCriteriaCategory.weight || 0,
          min_point: uniCriteriaCategory.min_point || 0,
          benchmark: uniCriteriaCategory.benchmark || 0,
          achievement: null,
          score: uniCriteriaCategory.score || 0,
          unit: null,
          star: uniCriteriaCategory.star
            ? parseInt(uniCriteriaCategory.star)
            : 0,
          showCriteria: true,
          achievement_options: null,
          criteria: []
        };
        let sortedUniCriteria = [];
        if (
          !_.isEmpty(uniCriteriaCategory.criteria) &&
          _.isArray(uniCriteriaCategory.criteria)
        ) {
          uniCriteriaCategory.criteria.forEach(criteriaItem => {
            let sortedCriteria = {
              id: criteriaItem.id,
              name: criteriaItem.criterion ? criteriaItem.criterion.name : "",
              description: criteriaItem.criterion
                ? criteriaItem.criterion.description
                : "",
              weight: criteriaItem.weight || 0,
              min_point: criteriaItem.min_point || 0,
              benchmark: criteriaItem.benchmark || 0,
              achievement_options: !_.isEmpty(criteriaItem.achievement_options)
                ? criteriaItem.achievement_options.split(",").sort()
                : "",
              achievement: criteriaItem.achievement || "",
              score: criteriaItem.score || 0,
              unit: criteriaItem.unit,
              star: parseInt(criteriaItem.star) || 0,
              criterion:
                criteriaItem.criterion ||
                (criteriaItem.criterion_id
                  ? { id: criteriaItem.criterion_id }
                  : null),
              criterion_id: criteriaItem.criterion_id,
              year: criteriaItem.year
            };
            sortedUniCriteria.push(sortedCriteria);
          });
        }
        sortedUniCriteriaCategory.criteria = sortedUniCriteria;
        sortedTabledData.push(sortedUniCriteriaCategory);
      });
      this.tableData = sortedTabledData;
      this.oldTableData = this.unsubscribeObservable(sortedTabledData);
      return this.tableData;
    },
    async exportExcel() {
      await new UniversityService().exportExcelRating(this.$route.params.id);
    },
    async getUniversityTypeOptions() {
      const response = await new UniversityTypeService().getList({
        limit: 1000
      });
      this.universityTypeOptions = response.data;
      return response.data;
    },
    async getUniversityDivisionOptions() {
      const response = await new UniversityDivisionService().getList({
        limit: 1000
      });
      this.universityDivisionOptions = response.data;
      return response.data;
    },
    unsubscribeObservable(data) {
      return JSON.parse(JSON.stringify(data));
    },
    isDisplay(column) {
      if (!this.columns) return true;
      return this.columns[column];
    },
    displayCriteria(category) {
      category.showCriteria = !category.showCriteria;
    },
    calcCategoryWeight(category) {
      if (!category || !category.criteria || _.isEmpty(category.criteria)) {
        return 0;
      }
      category.weight = category.criteria.reduce(function(sum, current) {
        return sum + parseFloat(current.weight || 0);
      }, 0);
      return category.weight;
    },
    calcCategoryScore(category) {
      if (!category || !category.criteria || _.isEmpty(category.criteria)) {
        return 0;
      }
      category.score = category.criteria.reduce(function(sum, current) {
        return sum + parseFloat(current.score || 0);
      }, 0);
      return category.score;
    },
    calcCriteriaScore(criteria) {
      let score = 0;
      const criterionId = criteria.criterion?.id ?? criteria.criterion_id;
      const w = parseFloat(criteria.weight) || 0;
      const a = parseFloat(criteria.achievement) || 0;
      const b = parseFloat(criteria.benchmark) || 0;
      const m = parseFloat(criteria.min_point) || 0;
      const ratingYear =
        parseInt(this.universitySummary?.year, 10) ||
        this.ratingYearFallback ||
        0;

      if (a >= b) {
        if (ratingYear >= 2026) {
          if (criterionId == 53) {
            // C14+ (E14-D14)
            score = this.roundHalf(w + (a - b)) || 0;
            criteria.score = score > 0 ? score : 0;
            return criteria.score;
          }

          if (criterionId == 54) {
            // C15+(E15-(benchmarking point))*2
            score = this.roundHalf(w + (a - b) * 2) || 0;
            criteria.score = score > 0 ? score : 0;
            return criteria.score;
          }

          if (criterionId == 65) {
            // C24+(E24-(benchmarking point))*10
            score = this.roundHalf(w + (a - b) * 10) || 0;
            criteria.score = score > 0 ? score : 0;
            return criteria.score;
          }

          if (criterionId == 66) {
            // C25+(E25-(benchmarking point))*2
            score = this.roundHalf(w + (a - b) * 2) || 0;
            criteria.score = score > 0 ? score : 0;
            return criteria.score;
          }

          if (criterionId == 72) {
            // C29+(E29-(benchmarking point))*2
            score = this.roundHalf(w + (a - b) * 2) || 0;
            criteria.score = score > 0 ? score : 0;
            return criteria.score;
          }
        }
        criteria.score = w;
        return criteria.score;
      }

      if (ratingYear >= 2026) {
        if (criterionId == 53) {
          // (E14-(min point))*(C14/(D14-(min point)))
          score = this.roundHalf((a - m) * (w / (b - m))) || 0;
          criteria.score = score > 0 ? score : 0;
          return criteria.score;
        }

        if (criterionId == 54) {
          // (E15-(min point))*(C15/(D15-(min point))))
          score = this.roundHalf((a - m) * (w / (b - m))) || 0;
          criteria.score = score > 0 ? score : 0;
          return criteria.score;
        }

        if (criterionId == 65) {
          // E24*(C24/D24)
          score = this.roundHalf(a * (w / b)) || 0;
          criteria.score = score > 0 ? score : 0;
          return criteria.score;
        }

        if (criterionId == 66) {
          // E25*(C25/D25)
          score = this.roundHalf(a * (w / b)) || 0;
          criteria.score = score > 0 ? score : 0;
          return criteria.score;
        }

        if (criterionId == 72) {
          // E29*(C29/D29)
          score = this.roundHalf(a * (w / b)) || 0;
          criteria.score = score > 0 ? score : 0;
          return criteria.score;
        }
      }
      score = this.roundHalf((w * (a - m)) / (b - m)) || 0;
      criteria.score = score > 0 ? score : 0;
      return criteria.score;
    },
    roundHalf(num) {
      return Math.round(num * 2) / 2;
    },
    calcCriteriaStar(criteria) {
      let percent = criteria.score / criteria.weight;
      if (percent > 0.75) {
        criteria.star = 5;
        return [criteria.star];
      }
      if (percent > 0.55 && percent <= 75) {
        criteria.star = 4;
        return [criteria.star];
      }
      if (percent > 0.35 && percent <= 55) {
        criteria.star = 3;
        return [criteria.star];
      }
      if (percent > 0.15 && percent <= 35) {
        criteria.star = 2;
        return [criteria.star];
      }
      if (percent > 0 && percent <= 0.15) {
        criteria.star = 1;
        return [criteria.star];
      }
      criteria.star = 0;
      return [criteria.star];
    },
    calcCategoryStar(category) {
      let percent = category.score / category.weight;

      if (percent > 0.75) {
        category.star = 5;
        category.plus_text = null;
        return [category.star];
      }
      if (percent > 0.55 && percent <= 75) {
        category.star = 4;
        category.plus_text = null;
        return [category.star];
      }
      if (percent > 0.35 && percent <= 55) {
        category.star = 3;
        category.plus_text = null;
        return [category.star];
      }
      if (percent > 0.15 && percent <= 35) {
        category.star = 2;
        category.plus_text = null;
        return [category.star];
      }
      if (percent > 0 && percent <= 0.15) {
        category.star = 1;
        category.plus_text = null;
        return [category.star];
      }
      category.star = 0;
      category.plus_text = null;
      return [category.star];
    },
    // calcTotalWeight() {
    //   this.totalWeight = this.tableData.reduce(function(sum, current) {
    //     return sum + parseFloat(current.weight || 0);
    //   }, 0);
    //   return this.totalWeight;
    // },
    // calcTotalScore() {
    //   this.totalScore = this.tableData.reduce(function(sum, current) {
    //     return sum + parseFloat(current.score || 0);
    //   }, 0);
    //   return this.totalScore;
    // },
    // calcTotalWeightForUpdate() {
    //   return this.oldTableData.reduce(function(sum, current) {
    //     return sum + parseFloat(current.weight || 0);
    //   }, 0);
    // },
    // calcTotalScoreForUpdate() {
    //   return this.oldTableData.reduce(function(sum, current) {
    //     return sum + parseFloat(current.score || 0);
    //   }, 0);
    // },
    // calcTotalStarForUpdate(totalScoreForUpdate, totalWeightForUpdate) {
    //   let percent = totalScoreForUpdate / totalWeightForUpdate;
    //   if (percent > 0.9) {
    //     return {
    //       star: 5,
    //       extra: "ELITE"
    //     };
    //   }
    //
    //   if (percent > 0.75 && percent <= 0.9) {
    //     return {
    //       star: 5,
    //       extra: null
    //     };
    //   }
    //
    //   if (percent > 0.67 && percent <= 0.75) {
    //     return {
    //       star: 4,
    //       extra: "PLUS"
    //     };
    //   }
    //
    //   if (percent > 0.55 && percent <= 0.67) {
    //     return {
    //       star: 4,
    //       extra: null
    //     };
    //   }
    //
    //   if (percent > 0.46 && percent <= 0.55) {
    //     return {
    //       star: 3,
    //       extra: "PLUS"
    //     };
    //   }
    //
    //   if (percent > 0.35 && percent <= 0.46) {
    //     return {
    //       star: 3,
    //       extra: null
    //     };
    //   }
    //
    //   if (percent > 0.25 && percent <= 0.35) {
    //     return {
    //       star: 2,
    //       extra: "PLUS"
    //     };
    //   }
    //
    //   if (percent > 0.15 && percent <= 0.25) {
    //     return {
    //       star: 2,
    //       extra: null
    //     };
    //   }
    //
    //   if (percent > 0 && percent <= 0.15) {
    //     return {
    //       star: 1,
    //       extra: null
    //     };
    //   }
    //
    //   return {
    //     star: 0,
    //     extra: null
    //   };
    // },
    async saveUniversityCriteriaRating(criteria, categoryIndex, criteriaIndex) {
      await this.updateUniversityCriteriaRating(criteria);
      await this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("management_university_score.updated_text", {
          name: this.universityInfo.name
        }),
        type: "success"
      });
      //Update oldTableData
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].score = this.unsubscribeObservable(criteria.score);
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].achievement = this.unsubscribeObservable(criteria.achievement);
      this.oldTableData[categoryIndex].weight = this.unsubscribeObservable(
        this.tableData[categoryIndex].weight
      );
      this.oldTableData[categoryIndex].score = this.unsubscribeObservable(
        this.tableData[categoryIndex].score
      );

      await this.getUniversityRatingSummaries();
    },
    async updateUniversityCriteriaRating(criteria) {
      const criteriaData = this.unsubscribeObservable(criteria);
      return await new UniversityRatingsService().update(
        criteriaData.id,
        criteriaData
      );
    },
    async getUniversityRatingSummaries() {
      this.universitySummary = await new UniversityService().getUniversityRatingSummaries(
        this.$route.params.id
      );
    },
    // async updateUniversityRatingSummaries() {
    //   let newSumWeight = this.calcTotalWeightForUpdate();
    //   let newSumScore = this.calcTotalScoreForUpdate();
    //   let newSumStar = this.calcTotalStarForUpdate(newSumScore, newSumWeight);
    //   let universityRatingSummariesParams = {
    //     weight: newSumWeight,
    //     score: newSumScore,
    //     star: newSumStar.star,
    //     extra: newSumStar.extra
    //   };
    //   return await new UniversityService().updateUniversityRatingSummaries(
    //     this.universityInfo.id,
    //     universityRatingSummariesParams
    //   );
    // },
    async updateAll() {
      $(".md-actions-btn").trigger("click", function(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
      });
      let formData = this.buildFormDataCreateUniversity();
      await this.updateUniversity(this.universityInfo.id, formData);
      return;
    },
    async updateUniversity(id, formData) {
      const response = await new UniversityService().update(id, formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          name: this.$t("university.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
    },
    buildFormDataCreateUniversity() {
      let params = this.universityInfo;
      params._method = "PATCH";
      return queryHelper.buildFormData(params);
    },
    equalsIgnoreOrder(a, b) {
      if (a.length !== b.length) return false;

      const uniqueValues = new Set([...a, ...b]);
      for (const v of uniqueValues) {
        const aCount = a.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) return false;
      }
      return true;
    },
    async getDetailUniversity() {
      this.universityInfo = await new UniversityService().getById(
        this.$route.params.id
      );
      this.title = this.universityInfo.name;
      this.template_updated = this.universityInfo.template_updated;
    },
    cancel() {
      this.$router.push({ name: "UniversityList" });
    },
    async updateRatingCriteria() {
      const response = await new UniversityService().updateUniRatingCriteria(
        this.$route.params.id
      );
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t(
          "management_university_score.updated_university_template"
        ),
        type: "success"
      });
      this.template_updated = true;
      await this.getTableData();
    }
  },
  computed: {
    summaryStar() {
      return this.universitySummary.star
        ? parseInt(this.universitySummary.star)
        : 0;
    }
    // calcTotalStar() {
    //   let percent = this.totalScore / this.totalWeight;
    //   if (percent > 0.9) {
    //     return {
    //       star: 5,
    //       plus_text: "ELITE"
    //     };
    //   }
    //
    //   if (percent > 0.75 && percent <= 0.9) {
    //     return {
    //       star: 5,
    //       plus_text: null
    //     };
    //   }
    //
    //   if (percent > 0.67 && percent <= 0.75) {
    //     return {
    //       star: 4.5,
    //       plus_text: null
    //     };
    //   }
    //
    //   if (percent > 0.55 && percent <= 0.67) {
    //     return {
    //       star: 4,
    //       plus_text: null
    //     };
    //   }
    //

    //   if (percent > 0.46 && percent <= 0.55) {
    //     return {
    //       star: 3.5,
    //       plus_text: null
    //     };
    //   }
    //
    //   if (percent > 0.35 && percent <= 0.46) {
    //     return {
    //       star: 3,
    //       plus_text: null
    //     };
    //   }
    //
    //   if (percent > 0.25 && percent <= 0.35) {
    //     return {
    //       star: 2.5,
    //       plus_text: null
    //     };
    //   }
    //
    //   if (percent > 0.15 && percent <= 0.25) {
    //     return {
    //       star: 2,
    //       plus_text: null
    //     };
    //   }
    //
    //   return {
    //     star: 1,
    //     plus_text: null
    //   };
    // }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/md/variables";
@import "src/assets/scss/md/manager-university-score";

.management-uni-btn {
  margin-left: 8px;
  font-size: 16px;
  border-radius: 3px;
  padding: 9px 10px;
  font-weight: 500;
  background: #9c27b0;
  color: #ffffff !important;
}
</style>
